import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
  C2_FONT,
  c2DialogPaperSx,
  c2DialogTitleSx,
  c2IconBoxSx,
  c2PrimaryBtnSx,
  c2SecondaryBtnSx,
  c2DangerBtnSx,
  c2SuccessBtnSx,
} from './conecta2ModalStyles';

/**
 * Diálogo Conecta2 unificado (mismo look que AlertDialog).
 * Uso: formularios OTP, monto, confirmaciones, etc.
 */
export default function C2Dialog({
  open,
  onClose,
  title,
  icon: Icon = InfoOutlinedIcon,
  children,
  actions,
  maxWidth = 420,
  disableEscapeKeyDown = false,
  ...dialogProps
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      disableEscapeKeyDown={disableEscapeKeyDown}
      PaperProps={{
        sx: { ...c2DialogPaperSx, maxWidth },
      }}
      {...dialogProps}
    >
      {title ? (
        <DialogTitle sx={c2DialogTitleSx}>
          <Box sx={c2IconBoxSx}>
            <Icon sx={{ color: '#6411ED', fontSize: 22 }} />
          </Box>
          {title}
        </DialogTitle>
      ) : null}
      <DialogContent
        sx={{
          px: 2.5,
          pb: 1,
          pt: title ? 0.5 : 2.5,
          fontFamily: C2_FONT,
        }}
      >
        {children}
      </DialogContent>
      {actions ? (
        <DialogActions sx={{ px: 2.5, pb: 2.5, pt: 1, gap: 1, flexWrap: 'wrap' }}>
          {actions}
        </DialogActions>
      ) : null}
    </Dialog>
  );
}

export function C2PrimaryButton(props) {
  return <Button variant="contained" {...props} sx={{ ...c2PrimaryBtnSx, ...props.sx }} />;
}

export function C2SecondaryButton(props) {
  return <Button variant="outlined" {...props} sx={{ ...c2SecondaryBtnSx, ...props.sx }} />;
}

export function C2DangerButton(props) {
  return <Button variant="outlined" {...props} sx={{ ...c2DangerBtnSx, ...props.sx }} />;
}

export function C2SuccessButton(props) {
  return <Button variant="contained" {...props} sx={{ ...c2SuccessBtnSx, ...props.sx }} />;
}
